/* eslint-disable react-hooks/exhaustive-deps */
import { Card } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import actions from "../../Redux Store/actions";
import {
	addLeadLogs,
	getAllCancelRequests,
	getCancelledRequest,
	updateAllotmentPaymentStatus,
	updateCancelRequests,
	updateLeadAllStatus,
} from "../../Services/ChangeUnitRequest";

import { errorTost, successTost } from "../../Services/Toast";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import ThreeDotsMenu from "../../Subcomponents/ThreeDotsMenu";
import Dot from "../Icons/Dot";
import cssClasses from "./CancelUnits.module.css";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import { supabase } from "../../supabaseClient";
import EmptyCancelUnitIcon from "../../Assets/Images/EmptyDataIcons/EmptyCancelUnit.svg";
import DropDown from "../../Subcomponents/DropDown";
import { dismissLoader, presentLoader } from "../../Services/loader";
import UserIcon from "../../Assets/Images/Common/ProfileUser-01.svg";
import ReactTimeAgo from "react-time-ago";
import BuildingIcon from "../../Assets/Images/Common/AllotmentBuildingIcon.svg";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";

TimeAgo.setDefaultLocale(en.locale);
TimeAgo.addLocale(en);
const menuItem = ["All", "Accepted", "Rejected", "Pending"];

export default function CancelUnits() {
	const dispatch = useDispatch();
	const [allRequests, setAllRequests] = useState([]);
	const [filterRequests, setFilterRequests] = useState([]);

	const [allRequestPresent, setAllRequestPresent] = useState(null);
	let loggedInUser = {};
	loggedInUser = useSelector((state) => state.Auth.user);
	const [openAlertBoxForCancellationConfirm, setOpenAlertBoxForCancellationConfirm] = useState(false);
	const [selectedCancellation, setSelectedCancellation] = useState(null);
	const [alertTitle, setAlertTitle] = useState("");
	const [alertSubTitle, setAlertSubTitle] = useState("");
	const [action, setAction] = useState(null);
	const [sort, setSort] = useState("All");
	const [openAlreadyCancelReq, setOpenAlreadyCancelReq] = useState({ value: false, msg: "" });
	useEffect(() => {
		dispatch(actions.activeMenu("cancelunits"));
		getAllRequests();
	}, []);
	// ??SnapShot
	useEffect(() => {
		let updateStatusListeners = supabase
			.from(`CancelUnitRequests:leadId=eq.${loggedInUser.leadId}`)
			.on("UPDATE", (handleRecordUpdated) => {
				getAllRequests();
			})

			.subscribe((status) => {
			});
		return () => {
			if (updateStatusListeners) {
				supabase.removeSubscription(updateStatusListeners);
				updateStatusListeners = null;
			}
		};
	}, []);

	useEffect(() => {
		setFilterRequests(allRequests);
	}, [allRequests]);

	function getAllRequests() {
		presentLoader();
		getAllCancelRequests(loggedInUser.leadId)
			.then((resp) => {
				resp.data = resp.data.map((el, index) => ({
					...el,
					id: el?.cancelUnitRequestId,
					index: index,
					leadName: el?.allotmentPaymentId?.leadId?.personId?.name ?? null,
					leadId: el?.allotmentPaymentId?.leadId?.leadId ?? null,
					leadConfirmationList: [],
				}));
				resp.data = resp.data.filter(({ leadId }) => leadId !== null);
				resp.data.forEach((el) => {
					if (el.status === "Pending" || el.status === "Cancelled In Farvision") {
						if (el.leadConfirmation === "Rejected") {
							el.leadConfirmationList.push("No actions available");
						} else if (el.leadConfirmation === "Accepted") {
							// if (el.allotmentPaymentId.status !== "cancelled") {
							//   el.leadConfirmationList.push("Cancel Request");
							// }
							el.leadConfirmationList.push("No actions available");
						} else if (el.cancelledInFarvision === true) {
							el.leadConfirmationList.push("No actions available");
						} else {
							el.leadConfirmationList.push("Confirm");
							el.leadConfirmationList.push("Cancel Request");
						}
					}
				});
				if (resp.data.length > 0) {
					setAllRequestPresent(true);
				} else {
					setAllRequestPresent(false);
				}
				setAllRequests([...resp.data]);
				dismissLoader();
			})
			.catch((err) => {
				console.log(err);
				dismissLoader();
			});
	}

	const handleChange = (event) => {
		const status = event;
		setSort(status);
		if (status === "All") {
			setFilterRequests(allRequests);
			setAllRequestPresent(true);
		} else {
			const selectedItem = allRequests.filter((item) => item.status === status);
			setFilterRequests(selectedItem);
			selectedItem.length > 0 ? setAllRequestPresent(true) : setAllRequestPresent(false);
		}
	};

	const handleCancelReq = async (req, e) => {
		presentLoader();
		await getCancelledRequest(req.cancelUnitRequestId).then((resp) => {
			if (resp) {
				if (resp[0].status === "Rejected" || resp[0].status === "Accepted") {
					setOpenAlreadyCancelReq({ value: true, msg: "Cancel Unit Request has already been processed." });
				} else if (resp[0].status === "Pending" && resp[0]?.leadConfirmation === "Accepted") {
					setOpenAlreadyCancelReq({ value: true, msg: "Cancel Unit Request currently in Process." });
				} else {
					dismissLoader();
					handleActionClicked(req, e)
				}
				dismissLoader();
			} else {
				dismissLoader();
				handleActionClicked(req, e);
			}

		})
	}
	function handleActionClicked(request, e) {
		if (e === "Confirm") {
			setSelectedCancellation(request);

			setAlertTitle("Do you really want to Cancel Unit?");

      		let date = request?.allotmentPaymentId?.pricingType === 'preselect' ? request?.allotmentPaymentId?.preselectConfirmationDate ? request?.allotmentPaymentId?.preselectConfirmationDate : request?.allotmentPaymentId?.firstPaymentDate : request?.allotmentPaymentId?.firstPaymentDate;
			var diffInSeconds =
				Math.abs(
			new Date(date) - new Date().valueOf()
				) / 1000;
			var days = Math.floor(diffInSeconds / 60 / 60 / 24);
			if (
				(request.allotmentPaymentId.status === "Payment Complete" ||
					request.allotmentPaymentId.status === "Partial Payment Done" ||
					request.allotmentPaymentId.status === "Cancellation Requested") &&
				request?.allotmentPaymentId?.firstPaymentDate !== null
			) {
				if (
					request?.allotmentPaymentId?.unitData?.farvisionStatus === "Hold" ||
					request?.allotmentPaymentId?.unitId?.farvisionStatus === "Hold"
				) {
					setAlertSubTitle("Cancellation charges may apply");
				} else {
					if (days < 15) {
						setAlertSubTitle(
							`Cancellation charges are not applicable for Unit ${request?.allotmentPaymentId?.unitId?.unitNo
							} in Wing ${request?.allotmentPaymentId?.unitId?.wingId.displayName
								? request?.allotmentPaymentId?.unitId?.wingId.displayName
								: request?.allotmentPaymentId?.unitId?.wingId.wingName
							} of project ${request?.allotmentPaymentId?.unitId?.projectId?.projectName
							}`
						);
					} else if (days >= 16 && days <= 30) {
						setAlertSubTitle(
							`The cancellation fee will be calculated as 1% of the unit cost for Unit ${request?.allotmentPaymentId?.unitId?.unitNo
							} in Wing ${request?.allotmentPaymentId?.unitId?.wingId.displayName
								? request?.allotmentPaymentId?.unitId?.wingId.displayName
								: request?.allotmentPaymentId?.unitId?.wingId.wingName
							} of project ${request?.allotmentPaymentId?.unitId?.projectId?.projectName
							}`
						);
					} else if (days > 30 && days <= 60) {
						setAlertSubTitle(
							`The cancellation fee will be calculated as 1.5% of the unit cost for Unit ${request?.allotmentPaymentId?.unitId?.unitNo
							} in Wing ${request?.allotmentPaymentId?.unitId?.wingId.displayName
								? request?.allotmentPaymentId?.unitId?.wingId.displayName
								: request?.allotmentPaymentId?.unitId?.wingId.wingName
							} of project ${request?.allotmentPaymentId?.unitId?.projectId?.projectName
							}`
						);
					} else if (days >= 61) {
						setAlertSubTitle(
							`The cancellation fee will be calculated as 2% of the unit cost  for Unit ${request?.allotmentPaymentId?.unitId?.unitNo
							} in Wing ${request?.allotmentPaymentId?.unitId?.wingId.displayName
								? request?.allotmentPaymentId?.unitId?.wingId.displayName
								: request?.allotmentPaymentId?.unitId?.wingId.wingName
							} of project ${request?.allotmentPaymentId?.unitId?.projectId?.projectName
							}`
						);
					}
				}
			} else if (request.allotmentPaymentId.status === "Payment Pending") {
				setAlertSubTitle(
					`Cancellation charges are not applicable for Unit ${request?.allotmentPaymentId?.unitId?.unitNo
					} in Wing ${request?.allotmentPaymentId?.unitId?.wingId.displayName
						? request?.allotmentPaymentId?.unitId?.wingId.displayName
						: request?.allotmentPaymentId?.unitId?.wingId.wingName
					} of project ${request?.allotmentPaymentId?.unitId?.projectId?.projectName}`
				);
			}
			setOpenAlertBoxForCancellationConfirm(true);
		} else if (e === "Cancel Request") {
			setSelectedCancellation(request);
			setAlertTitle("Do you really want to cancel the request?");
			setAlertSubTitle(
				`Cancellation charges are not applicable for Unit ${request?.allotmentPaymentId?.unitId?.unitNo
				} in Wing ${request?.allotmentPaymentId?.unitId?.wingId.displayName
					? request?.allotmentPaymentId?.unitId?.wingId.displayName
					: request?.allotmentPaymentId?.unitId?.wingId.wingName
				} of project ${request?.allotmentPaymentId?.unitId?.projectId?.projectName}`
			);
			setOpenAlertBoxForCancellationConfirm(true);
		}
	}
	return (
		<div className={cssClasses.wrapperPage}>
			<div className={cssClasses.mainContent}>
				<div className={cssClasses.headerMainContent}>
					<div className={cssClasses.wrapperHeader}>
						<div className={cssClasses.headerTitle}>{allRequests.length} Cancel Unit Requests</div>
						{(allRequestPresent || allRequests.length > 0) && (
							<div className={cssClasses.searchData}>
								<div className={cssClasses.dropdownWrapper}>
									<DropDown
										onChangeSelect={(e) => {
											handleChange(e);
										}}
										selectedValue={sort}
										style={{
											selectedColor: "#657084",
											background: "#F2F4F7",
										}}
										list={menuItem}
									/>
								</div>
							</div>
						)}
					</div>
				</div>
				<div className={cssClasses.eventsWrapper}>
					{allRequestPresent &&
						filterRequests.map((request) => (
							<Card className={cssClasses.eventWrap} key={request.id}>
								<div className={cssClasses.cardHeader}>
									<div className={cssClasses.tokenNumWrap}>
										{request?.allotmentPaymentId?.unitId && (
											<span className={cssClasses.unitId}>
												<div className={cssClasses.buildingImg}>
													<img src={BuildingIcon} alt="building" />
												</div>
												<div className={cssClasses.cancelUnitStatus}>
													<div className={cssClasses.projectNameChip}>
														<div>
															{request?.allotmentPaymentId?.unitId?.wingId?.displayName
																? request?.allotmentPaymentId?.unitId?.wingId?.displayName
																: request?.allotmentPaymentId?.unitId?.wingId?.wingName}{" "}
															- {request?.allotmentPaymentId?.unitId?.unitNo}{" "}
														</div>
														<div className={cssClasses.tokenStatus}>
															{request.cancelledInFarvision === true ? (
																<LeadStatusChip
																	label={"Cancelled In Farvision"}
																	icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
																	style={{
																		color: "#B42318",
																		backgroundColor: "#FEF3F2",
																	}}
																></LeadStatusChip>
															) : (
																<>
																	{request.status === "Accepted" && request.requestPendingWithUserId === null && (
																		<LeadStatusChip
																			label={"Accepted"}
																			icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
																			style={{
																				color: "#027A48",
																				backgroundColor: "#ECFDF3",
																			}}
																		/>
																	)}
																	{(request.status === "Rejected" || request.leadConfirmation === "Rejected") && (
																		<LeadStatusChip
																			label={"Rejected"}
																			icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
																			style={{
																				color: "#B54708",
																				backgroundColor: "#FFFAEB",
																			}}
																		/>
																	)}
																	{(request.status === "Pending" ||
																		request.leadConfirmation === "Pending" ||
																		request.requestPendingWithUserId !== null) &&
																		request.status !== "Rejected" &&
																		request?.leadConfirmation !== "Rejected" && (
																			<LeadStatusChip
																				label={"Pending"}
																				icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
																				style={{
																					color: "#B42318",
																					backgroundColor: "#FEF3F2",
																				}}
																			/>
																		)}
																</>
															)}
														</div>
													</div>
													{request?.allotmentPaymentId?.unitId && (
														<span className={cssClasses.projectName}>
															{request?.allotmentPaymentId?.unitId.projectId.projectName}
														</span>
													)}
													{request?.allotmentPaymentId?.inventoryMergedId && (
														<span className={cssClasses.projectName}>
															{request?.allotmentPaymentId?.inventoryMergedId.projectId.projectName}
														</span>
													)}
												</div>
											</span>
										)}
										{request?.allotmentPaymentId?.inventoryMergedId &&
											((request?.allotmentPaymentId?.inventoryMergedId.unit1Id.wingId.wingId ===
												request?.allotmentPaymentId?.inventoryMergedId.unit2Id.wingId.wingId && (
													<span>
														{request?.allotmentPaymentId?.inventoryMergedId.unit1Id.wingId.displayName
															? request?.allotmentPaymentId?.inventoryMergedId.unit1Id.wingId.displayName
															: request?.allotmentPaymentId?.inventoryMergedId.unit1Id.wingId.wingName}{" "}
														- {request?.allotmentPaymentId?.inventoryMergedId.unit1Id.unitNo} &{" "}
														{request?.allotmentPaymentId?.inventoryMergedId.unit2Id.unitNo}{" "}
													</span>
												)) ||
												(request?.allotmentPaymentId?.inventoryMergedId.unit1Id.wingId.wingId !==
													request?.allotmentPaymentId?.inventoryMergedId.unit2Id.wingId.wingId && (
														<span>
															{request?.allotmentPaymentId?.inventoryMergedId.unit1Id.wingId.displayName
																? request?.allotmentPaymentId?.inventoryMergedId.unit1Id.wingId.displayName
																: request?.allotmentPaymentId?.inventoryMergedId.unit1Id.wingId.wingName}{" "}
															- {request?.allotmentPaymentId?.inventoryMergedId.unit1Id.unitNo} &{" "}
															{request?.allotmentPaymentId?.inventoryMergedId.unit2Id.wingId.displayName
																? request?.allotmentPaymentId?.inventoryMergedId.unit2Id.wingId.displayName
																: request?.allotmentPaymentId?.inventoryMergedId.unit2Id.wingId.wingName}{" "}
															- {request?.allotmentPaymentId?.inventoryMergedId.unit2Id.unitNo}{" "}
														</span>
													)))}
									</div>
									<div className={cssClasses.actionContent}>
										<div className={cssClasses.lastUpdate}>
											<ReactTimeAgo
												style={{ fontSize: "1.2rem" }}
												date={request?.last_updated_at ?? request?.created_at}
												locale="en-US"
											/>
										</div>
										{request.leadConfirmationList.length > 0 && (
											<div className={cssClasses.tokenActions}>
												<ThreeDotsMenu
													list={request.leadConfirmationList}
													selectedValue={(e) => {
														console.log(request)
														handleCancelReq(request, e)
														setAction(e);
													}}
												/>
											</div>
										)}
									</div>
								</div>

								<div className={cssClasses.cardDetails}>
									<div className={cssClasses.cardData}>
										{request?.userId?.name && (
											<div style={{ display: "flex", gap: "0.5rem" }}>
												<img className={cssClasses.smIcon} src={UserIcon} alt="User" />
												<div className={cssClasses.leadMessage}>
													SM:<div className={cssClasses.smName}>{request?.userId?.name}</div>
												</div>
											</div>
										)}
										{request?.status === "Pending" && request?.leadConfirmation === "Pending" && (
											<div className={cssClasses.unitConfirmationText}>Your confirmation is pending</div>
										)}
										{request?.status === "Pending" && request?.leadConfirmation === "Accepted" && (
											<div className={cssClasses.unitConfirmationText}>You have confirmed this request</div>
										)}
										{request?.status === "Pending" && request?.leadConfirmation === "Rejected" && (
											<div className={cssClasses.unitConfirmationText}>You have rejected this request</div>
										)}
									</div>
								</div>
							</Card>
						))}
					{allRequestPresent === false && (
						<div className={cssClasses.noDataWrapper}>
							<div className={cssClasses.noDataMsg}>
								<div className={cssClasses.emptyIcon}>
									<img src={EmptyCancelUnitIcon} alt="No Requests" />
								</div>
								<div className={cssClasses.emptyTitle}>No Cancel Request Pending</div>
							</div>
						</div>
					)}
				</div>
			</div>

			{openAlertBoxForCancellationConfirm && (
				<ConfirmationAlert
					confirm={(e) => {
						if (e === "confirmed") {
							setSort("All");
							if (action === "Confirm") {
								// ! this is when customer is accepting request; hence this must go to parent of sales manager for approval
								let requestPendingObj = {
									roleId: loggedInUser?.userId?.parentId ? loggedInUser?.userId?.parentId?.roleId : null,
									parentId: loggedInUser?.userId?.parentId ? loggedInUser?.userId?.parentId?.userId : null,
								};
								updateCancelRequests(selectedCancellation.cancelUnitRequestId, "Accepted", requestPendingObj)
									.then((resp) => {
										updateLeadAllStatus(
											loggedInUser?.leadId,
											`Cancellation Confirmation Pending by ${loggedInUser?.userId?.parentId?.name}`
										)
											.then((updateLeadStatus) => {
												let obj = {
													leadId: loggedInUser?.leadId,
													leadStatus: `Cancellation Confirmation Pending by ${loggedInUser?.userId?.parentId?.name}`,
													message: `Cancellation Confirmation Pending by ${loggedInUser?.userId?.parentId?.name}. Cancellation request confirmed by lead`,
												};
												addLeadLogs(obj)
													.then((leadLog) => {
													})
													.catch((err) => {
														console.log("leadlog", err);
													});
												updateAllotmentPaymentStatus(
													selectedCancellation.allotmentPaymentId.allotmentPaymentId,
													"Cancellation Pending"
												).then((resp) => {
													successTost("Cancellation request confirmed. Contact your VJ SM for further details!");
													setOpenAlertBoxForCancellationConfirm(false);
													getAllRequests();
												});
											})
											.catch((err) => {
												console.log(err, "err while updating change unit request");
											});
									})
									.catch((err) => {
										console.log(err);
										errorTost("Error while confirming");
									});
							} else if (action === "Cancel Request") {
								updateCancelRequests(selectedCancellation.cancelUnitRequestId, "Rejected")
									.then(async (resp) => {
										let leadStatusResp = await supabase.rpc("getoldleadstatus", { "leadid": loggedInUser?.leadId })

										updateLeadAllStatus(loggedInUser?.leadId, leadStatusResp?.data[0]?.leadstatus)
											.then((updateLeadStatus) => {
												let obj = {
													leadId: loggedInUser?.leadId,
													leadStatus: leadStatusResp?.data[0]?.leadstatus,
													message: `Cancellation request rejected by lead through customer portal`,
												};
												addLeadLogs(obj)
													.then((leadLog) => {
													})
													.catch((err) => {
														console.log("leadlog", err);
													});
												updateAllotmentPaymentStatus(
													selectedCancellation.allotmentPaymentId.allotmentPaymentId,
													selectedCancellation.allotmentPaymentId.paidAmount < selectedCancellation.allotmentPaymentId.bookingAmt.total ? "Partial Payment Done" : "Payment Complete"
												).then((resp) => { });
												successTost("Cancelled request successfully!");
												getAllRequests();
												setOpenAlertBoxForCancellationConfirm(false);
											})
											.catch((err) => {
												console.log(err, "err while updating cancel unit request");
											});
									})
									.catch((err) => {
										console.log(err);
										errorTost("Error while cancelling");
									});
							}
						}
					}}
					buttonTitle={"No"}
					returnRespButton={"Yes"}
					close={() => setOpenAlertBoxForCancellationConfirm(false)}
					title={alertTitle}
					subTitle={alertSubTitle}
					open={openAlertBoxForCancellationConfirm}
				/>
			)}
			{openAlreadyCancelReq && (
				<ConfirmationAlert
					close={() => {
						setOpenAlreadyCancelReq({ value: false, msg: "" });
						window.location.reload();							// handleClose();
					}}
					open={openAlreadyCancelReq.value}
					buttonTitle={"Cancel"}
					title={"Warning"}
					subTitle={openAlreadyCancelReq.msg}
					confirm={(e) => {
						setOpenAlreadyCancelReq({ value: false, msg: "" });
						window.location.reload();
					}}
				/>
			)}
		</div>
	);
}
